/**
 * Route for `cake-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CakeIntegrationViaApiPage } from "../features/cake-integration-via-api/CakeIntegrationViaApiPage";

export const cakeIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cake-integration-via-api",
	component: CakeIntegrationViaApiPage,
});

export default cakeIntegrationViaApiRoute;
